import React from "react";

const InputText = ({ name, className = "", value, onChange, placeholder }) => {
  return (
    <div className="input-text">
      <input
        name={name}
        className={`styled-input ${className}`}
        value={value}
        onChange={(e) => onChange(e)}
        placeholder={placeholder}
        type="text"
      />
    </div>
  );
};

export default InputText;
